import { HTTP_DESKRH } from '../http';

export default {

  getPartnerships(params) {
    return HTTP_DESKRH.post('/partnerships', params);
  },

  getPartnership(id) {
    return HTTP_DESKRH.get(`/partnership/${id}`);
  },

  updatePartnership(partnership) {
    return HTTP_DESKRH.put(`/partnership/${partnership.id}`, partnership);
  },

  updatePartnershipTransmissionMode(partnership) {
    return HTTP_DESKRH.put(`/partnership/${partnership.id}/transmission-mode`, { transmissionMode: partnership.transmissionMode });
  },

  addPartnership(params) {
    return HTTP_DESKRH.post('/partnership', params);
  },

  getPartnershipsGroups(params) {
    return HTTP_DESKRH.post('/partnership-groups', params);
  },

  disablePartnership(id) {
    return HTTP_DESKRH.post(`/partnership/${id}/disable`)
      .then(data => data);
  },

  enablePartnership(id) {
    return HTTP_DESKRH.post(`/partnership/${id}/enable`)
      .then(data => data);
  },

  createPartnershipsGroup(params) {
    return HTTP_DESKRH.post('/partnership-group', params)
      .then(data => data);
  },

  getPartnershipGroup(id) {
    return HTTP_DESKRH.get(`/partnership-group/${id}`);
  },

  updateThirdPartyGroup(group) {
    return HTTP_DESKRH.put(`/partnership-group/${group.id}`, group)
      .then(data => data);
  },
  deleteThirdPartyGroup(id) {
    return HTTP_DESKRH.delete(`/partnership-group/${id}`)
      .then(data => data);
  },

  getUnvalidatedPartnerships(params) {
    return HTTP_DESKRH.post('partnerships/need-user-action', params)
      .then(data => data);
  },

  finalizePartnership(params) {
    return HTTP_DESKRH.post(`/partnership/${params.id}/fill-contact-mail`, { email: params.email, reference: params.reference })
      .then(data => data);
  },

  validateThirdPartyMail(params) {
    return HTTP_DESKRH.post(`/partnership/${params.id}/validating-mail`, { email: params.email, reference: params.reference })
      .then(data => data);
  },

};



// WEBPACK FOOTER //
// ./src/api/partnerships.js